define('../src/sublayouts/m7-tabs/m7-tabs',['jquery'], function($) {

    'use strict';

    var M7_TABS = function($component) {

        this.$component = $component;

        return this;
    };


    M7_TABS.prototype.init = function() {
        var _this = this,
            subTab = _this.$component.find('.m7-tabs').length > 0 ? true : false,
            downloadTrigger = _this.$component.find('.m5-section-titletext-download');

        this.initTabs();
        this.checkTabs();

        $(window).off('tab.m7').on('tab.m7', function () {
            _this.init();
        });
            
        downloadTrigger.on('click',function(){
          if($(window).width() < 1025){
              var wrapper = $(this).closest('.download-wrapper');
              if(!wrapper.hasClass('hover-down')){
                  wrapper.addClass('hover-down')
              }else{
                  wrapper.removeClass('hover-down')
              }
          }
      })

            
            var hideDropdownTimeout; // Declare a variable to hold the timeout reference
            
            _this.$component.find("#fff").click(function(event) {
              event.stopPropagation();
              _this.$component.find(".dropdown").slideUp();
              $(this).toggleClass("open");
              _this.$component.find(".dropdown").slideToggle();
            });
          
            // Add mouseleave event to .dropdown and #fff elements
            _this.$component.find(".dropdown, #fff").mouseleave(function() {
              // Set a timeout to hide the dropdown after a short delay
              hideDropdownTimeout = setTimeout(function() {
                _this.$component.find(".dropdown").slideUp();
                _this.$component.find("#fff").removeClass("open");
              }, 300); // Adjust the delay as needed
            });
          
            // Add mouseenter event to .dropdown and #fff elements
            _this.$component.find(".dropdown, #fff").mouseenter(function() {
              // Clear the hideDropdownTimeout when the mouse re-enters the elements
              clearTimeout(hideDropdownTimeout);
            });
          
            _this.$component.find(".checkbox-option").change(function() {
              updateSelectedOptions();
              const selectedCount = _this.$component.find(".checkbox-option:checked").length;
              
              const selectAllOption = _this.$component.find(".select-all-option");
              selectAllOption.text(selectedCount > 0 ? selectAllOption.data("deselect-text") + ` (${selectedCount})` : selectAllOption.data("select-text"));
            });
          
            function updateSelectedOptions() {
              const selectedOptions = _this.$component.find(".checkbox-option:checked").not("#select-all").map(function() {
                const optionText = $(this).next("label").text();
                const customNumber = $(this).data("custom-number");
                return '<div class="selected-option">' + optionText + '<span class="remove-option icon-close" data-custom-number="' + customNumber + '"></span></div>';
              }).get();
              
              const defaultText = _this.$component.find(".selected-options").data("default-text");
              const selectedOptionsText = selectedOptions.length > 0 ? selectedOptions.join("") : '<span class="default-text">' + defaultText + '</span>';
              _this.$component.find(".selected-options").html(selectedOptionsText);
              
              // Attach click handler for removing selected option
              _this.$component.find(".remove-option").click(function(event) {
                event.stopPropagation();
                const customNumber = $(this).data("custom-number");
                _this.$component.find(".checkbox-option[data-custom-number='" + customNumber + "']").prop("checked", false);
                updateSelectedOptions();
                updateSelectAllText();
              });
              
              updateSelectAllText();
            }
          
            function updateSelectAllText() {
              const selectedCount = _this.$component.find(".checkbox-option:checked").not("#select-all").length;
              const selectAllOption = _this.$component.find(".select-all-option");
              if (selectedCount === 0) {
                selectAllOption.text(selectAllOption.data("select-text"));
              } else {
                const totalOptions = _this.$component.find(".checkbox-option").not("#select-all").length;
                if (selectedCount === totalOptions) {
                  selectAllOption.text(selectAllOption.data("deselect-text") + ` (${selectedCount})`);
                } else {
                  selectAllOption.text(selectAllOption.data("deselect-text") + ` (${selectedCount})`);
                }
              }
            }
          
            _this.$component.find(".select-all-option").click(function() {
              const selectAllOption = _this.$component.find(".select-all-option");
              const isDeselectText = selectAllOption.text().indexOf(selectAllOption.data("deselect-text")) === 0;
              
              _this.$component.find(".checkbox-option").prop("checked", !isDeselectText);
              
              if (isDeselectText) {
                selectAllOption.text(selectAllOption.data("select-text"));
              } else {
                const totalOptions = _this.$component.find(".checkbox-option").not("#select-all").length;
                selectAllOption.text(selectAllOption.data("deselect-text") + ` (${totalOptions})`);
              }
              
              updateSelectedOptions();
            });

          
          
          
          
          
          
          
              

    };

    M7_TABS.prototype.initTabs = function() {
        var _this = this,
            $tabs = this.$component.find('.m7-tabs-list').first().find('.m7-tabs-listitem');

        $tabs.off('click.m7').on('click.m7', function () {
            $tabs.removeClass('active');

            $(this).addClass('active');
            $(this).focusout();

            _this.checkTabs();
            if(_this.$component.hasClass('m7-tabs--calendar')){
                jQuery('.m9-scroller--main').trigger('scroll.m9')
            }
        });
    };

    M7_TABS.prototype.checkTabs = function() {
        var _this = this,
            $activeTab = this.$component.find('.m7-tabs-list').first().find('.m7-tabs-listitem.active'),
            $activeContent = this.$component.find('.m7-tabs-content').first().children('.m7-tabs-contentitem[tab-index="'+$activeTab.attr('tab-index')+'"]'),
            $content = this.$component.find('.m7-tabs-content').first().children('.m7-tabs-contentitem');

        $content.removeClass('active');

        $activeContent.addClass('active');

    };

    return M7_TABS;
});


